import * as React from 'react';

function CardIconGreen(props) {
  return (
    <svg width={72} height={72} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M14.189 30.669c-.767-2.105-1.15-3.158-1.033-4.111a4 4 0 011.045-2.24c.655-.703 1.708-1.086 3.813-1.852l22.74-8.277c2.105-.767 3.158-1.15 4.111-1.033a4 4 0 012.24 1.045c.703.655 1.086 1.708 1.852 3.813l5.2 14.283c.765 2.105 1.148 3.158 1.031 4.111a4 4 0 01-1.044 2.24c-.655.703-1.708 1.086-3.813 1.852l-22.74 8.277c-2.106.766-3.158 1.15-4.111 1.032a4 4 0 01-2.24-1.044c-.703-.655-1.086-1.708-1.853-3.813L14.19 30.669z'
        fill='url(#prefix__paint0_linear_70_6783)'
      />
      <path fill='#fff' fillOpacity={0.9} d='M13.796 29.588l34.768-12.655 1.796 4.934L15.591 34.52z' />
      <g filter='url(#prefix__filter0_bi_70_6783)'>
        <path
          d='M23 36a4 4 0 014-4h29a4 4 0 014 4v20a4 4 0 01-4 4H27a4 4 0 01-4-4V36z'
          fill='#72BF44'
          fillOpacity={0.5}
        />
      </g>
      <rect x={28.236} y={42.076} width={6.982} height={5.236} rx={2} fill='#fff' fillOpacity={0.9} />
      <rect x={28.315} y={52.549} width={5.236} height={3.491} rx={1.745} fill='#fff' fillOpacity={0.9} />
      <rect x={35.298} y={52.549} width={5.236} height={3.491} rx={1.745} fill='#fff' fillOpacity={0.9} />
      <rect x={42.279} y={52.549} width={5.236} height={3.491} rx={1.745} fill='#fff' fillOpacity={0.9} />
      <rect x={49.261} y={52.549} width={5.236} height={3.491} rx={1.745} fill='#fff' fillOpacity={0.9} />
      <defs>
        <linearGradient
          id='prefix__paint0_linear_70_6783'
          x1={13.136}
          y1={13.136}
          x2={49.67}
          y2={8.267}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
        <filter
          id='prefix__filter0_bi_70_6783'
          x={19}
          y={28}
          width={45}
          height={36}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_70_6783' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_70_6783' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_70_6783' />
        </filter>
      </defs>
    </svg>
  );
}

export default CardIconGreen;
